/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import {
  defaultBackgroundColor1,
  defaultBackgroundColor2,
  defaultBackgroundGradientDirection
} from "../../layouts/LayoutPortalUtil";

const createLoginTemplates = {
  name: "Default",
  startingStep: 0,
  steps: [
    {
      stepName: "Branding",
      title: "Brand your Login Page",
      preview: "login",
      substeps: [
        {
          type: "element",
          title: "Add Logo",
          config: {
            element: "staticImage",
            layer: "foreground",
            dimension: {
              row: 6,
              col: 5,
              height: 16,
              width: 20,
            },
            default: {
              url: "",
              boxAlign: "middle center",
              size: 100,
              boxMaxWidth: 700
            },
            advanced: [ "size", "boxAlign" ],
            hidden: [ "boxMaxWidth" ]
          }
        },
        {
          type: "element",
          title: "Title Text",
          config: {
            element: "customLabel",
            layer: "foreground",
            dimension: {
              row: 4,
              col: 21,
              height: 8,
              width: 24,
            },
            default: {
              text: "Enter Title",
              bodyText: "Enter Text",
              size: "md",
              bodySize: "md",
              align: "center",
              style: { bold: false, italic: false, underline: false },
              font: "Rubik",
              color: "#000000",
              boxAlign: "middle center",
              boxMaxWidth: "600",
            },
            advanced: [ "align", "style" ]
          }
        },
        {
          type: "background",
          title: "Background Configuration",
          config: {
            type: "gradient",
            color: defaultBackgroundColor1,
            gradientColor1: defaultBackgroundColor1,
            gradientColor2: defaultBackgroundColor2,
            gradientDirection: defaultBackgroundGradientDirection,
            image: undefined
          }
        },
        {
          type: "termsAndCondition",
          title: "Terms and Conditions",
          config: {}
        }
      ]
    },
    {
      stepName: "Login",
      title: "Choose up to 5 Login Options",
      preview: "login",
      substeps: [
        {
          type: "element",
          title: null,
          config: {
            element: "loginFields",
            layer: "foreground",
            togglable: false,
            dimension: {
              row: 4,
              col: 29,
              height: 17,
              width: 24
            },
            default: {
              loginMethod: {
                methods: [
                  { type: "email", backgroundColor: "#EE8800" },
                  { type: "sms", backgroundColor: "#25D366" },
                  { type: "facebook", backgroundColor: "#3B5998" },
                ],
                passcode: "1234",
                countryCode: "+1",
                buttonStyle: "default",
                textAlign: "left",
                showIcons: true
              },
              boxAlign: "center",
              boxMaxWidth: "600",
            },
            hidden: [ "boxMaxWidth" ]
          }
        },
        {
          type: "element",
          title: "Framing Box Color",
          advanced: true,
          config: {
            element: "rectangle",
            layer: "framing",
            dimension: {
              row: 2,
              col: 4,
              height: 43,
              width: 28,
            },
            default: {
              color: "#FFFFFF80",
              borderColor: "#00000000",
              boxAlign: "center",
              boxMaxWidth: "750",
            },
            hidden: [
              "borderColor", "boxAlign", "boxMaxWidth"
            ]
          },
        },
      ]
    },
    {
      stepName: "Post-Login",
      title: "Choose what happens after guests login",
      preview: "postLogin",
      substeps: [
        {
          type: "postLoginPage",
          title: null,
          config: {}
        },
        {
          type: "redirectPage",
          title: "Redirect Page",
          config: {}
        }
      ]
    },
    {
      stepName: "Options",
      title: "Additional Options",
      preview: "login",
      substeps: [
        {
          type: "fullPreview",
          title: null,
          config: {}
        },
        {
          type: "language",
          title: "Language Settings",
          config: {}
        },
        {
          type: "element",
          title: "Language Settings",
          hidden: true,
          config: {
            element: "localizationBar",
            layer: "foreground",
            dimension: {
              row: 9,
              col: 1,
              height: 2,
              width: 14,
            },
            default: {
              language: "",
              boxAlign: "center",
              boxMaxWidth: "360",
              visible: false
            },
            hidden: [
              "boxAlign", "boxMaxWidth"
            ]
          },
        },
        {
          type: "loginVerification",
          title: "Login Verification",
          config: {}
        },
        {
          type: "gdpr",
          title: "Marketing Consent",
          config: {}
        },
        {
          type: "preLoginVideo",
          title: "Pre-Login Video",
          config: {}
        }
      ]
    }
  ]
};

const getCreateLoginTemplates = () => {
  return JSON.parse(JSON.stringify(createLoginTemplates));
}

export default getCreateLoginTemplates;
